module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"test":"value"}}')
  delete Component.options._Ctor
}
